import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const InviteIcon = ({ color = '#B5BCBD', size = '20', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.2 13.563H28v-3.25a.809.809 0 0 0-.8-.813h-1.6c-.44 0-.8.366-.8.813v3.25h-3.2c-.44 0-.8.365-.8.812V16c0 .447.36.813.8.813h3.2v3.25c0 .446.36.812.8.812h1.6c.44 0 .8-.366.8-.813v-3.25h3.2c.44 0 .8-.365.8-.812v-1.625a.809.809 0 0 0-.8-.813zM11.2 16c3.535 0 6.4-2.91 6.4-6.5S14.735 3 11.2 3 4.8 5.91 4.8 9.5 7.665 16 11.2 16zm4.48 1.625h-.835a8.6 8.6 0 0 1-3.645.813c-1.3 0-2.53-.295-3.645-.813H6.72C3.01 17.625 0 20.682 0 24.45v2.113C0 27.907 1.075 29 2.4 29H20c1.325 0 2.4-1.092 2.4-2.438V24.45c0-3.768-3.01-6.825-6.72-6.825z"
      fill={color}
    />
  </svg>
);

InviteIcon.propTypes = propTypes;

export default InviteIcon;
